import { faQuestionCircle } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

import { linkize } from "@/mk2/apps/strollers/utils";
import { ExpandableClamp } from "@/mk2/components/ExpandableClamp";
import { SHOW_FULL_ANSWER } from "@/mk/autogenerated/translation";

import styles from "./QuestionAndAnswer.mscss";

interface OwnProps {
    question: string;
    answer: string;
}

export const QuestionAndAnswer: React.FunctionComponent<OwnProps> = ({ answer, question }) => (
    <div className={styles.QuestionAndAnswer}>
        <div className={styles.QuestionAndAnswer__question}>
            <FontAwesomeIcon
                icon={faQuestionCircle}
                className={styles.QuestionAndAnswer__question__icon}
            />
            <div className={styles.QuestionAndAnswer__question__text}>{question}</div>
        </div>
        <div className={styles.QuestionAndAnswer__answer}>
            <ExpandableClamp expandLabel={SHOW_FULL_ANSWER} clamp={3}>
                <div>{linkize(answer)}</div>
            </ExpandableClamp>
        </div>
    </div>
);

QuestionAndAnswer.displayName = "QuestionAndAnswer";
